var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('transition',{attrs:{"name":"preview-button","appear":""}},[(_vm.isPreviewMode)?_c('preview-button-inner',_vm._b({},'preview-button-inner',_vm.$attrs,false)):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }